// src/pages/NotFoundPage.js
import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function NotFoundPage() {
  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)' }}>
      <Navbar />
      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'calc(100vh - 62px)', gap:20, padding:24 }}>
        <p style={{ fontFamily:'Cormorant Garamond,serif', fontSize:80, color:'var(--gold)', fontWeight:300, lineHeight:1 }}>404</p>
        <p style={{ fontSize:14, color:'var(--muted)', letterSpacing:2, textTransform:'uppercase' }}>Page not found</p>
        <Link to="/" className="btn btn--outline btn--sm" style={{ marginTop:8 }}>← Back to Home</Link>
      </div>
    </div>
  )
}
